import { render } from "./MonitorStudentsDataTable.vue?vue&type=template&id=96c52fd6&scoped=true"
import script from "./MonitorStudentsDataTable.vue?vue&type=script&lang=js"
export * from "./MonitorStudentsDataTable.vue?vue&type=script&lang=js"

import "./MonitorStudentsDataTable.vue?vue&type=style&index=0&id=96c52fd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c52fd6"]])

export default __exports__